import { AttackPattern, PatternState } from '../AttackPattern.js';
import { ARENA } from '../../../../config/constants.js';

/**
 * Area Denial — exclusive to Ashen Throne. Telegraphs several zones
 * scattered across the (now much larger, per Phase A) arena; anyone still
 * standing in one when the telegraph ends takes damage. Unlike the
 * boss-centered patterns, this one's about the arena itself — forcing the
 * player to actually relocate across the wider space rather than just
 * dodge around the boss.
 *
 * `config` (zoneCount/zoneRadius/damage) is per-boss tuning, supplied by
 * data/bosses.js.
 */
export class AreaDenial extends AttackPattern {
  constructor({ minPhase = 1, config }) {
    super({ name: 'Area Denial', telegraphDuration: 1.1, activeDuration: 0.3, minPhase, arenaControl: true });
    this.config = config;
  }

  onBegin() {
    const { zoneCount, zoneRadius } = this.config;
    this._zones = [];
    for (let i = 0; i < zoneCount; i++) {
      this._zones.push({
        x: ARENA.x + zoneRadius + Math.random() * (ARENA.width - zoneRadius * 2),
        y: ARENA.y + zoneRadius + Math.random() * (ARENA.height - zoneRadius * 2),
        radius: zoneRadius,
      });
    }
  }

  onActiveStart(_boss, player) {
    const { damage } = this.config;
    for (const zone of this._zones) {
      const dist = Math.hypot(player.x - zone.x, player.y - zone.y);
      if (dist < zone.radius + player.radius) player.takeDamage(damage);
    }
  }

  getVisual() {
    if (this.state === PatternState.TELEGRAPH || this.state === PatternState.ACTIVE) {
      return { kind: 'denialZones', zones: this._zones, imminent: this.state === PatternState.ACTIVE };
    }
    return null;
  }
}
